module.exports = __webpack_public_path__ + "static/img/A.f25c785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/A.png
// module id = SFwc
// module chunks = 0